import { CollectionState } from './state';
import { GenresResponse } from '../api';
import {
    ANALYSE_FAILURE,
    ANALYSE_REQUEST,
    ANALYSE_RESET_AFTER_FAILURE,
    ANALYSE_SUCCESS,
    COLLECTION_BY_GENRE_PRODUCTS_FAILURE,
    COLLECTION_BY_GENRE_PRODUCTS_REQUEST,
    COLLECTION_BY_GENRE_PRODUCTS_RESET,
    COLLECTION_BY_GENRE_PRODUCTS_SUCCESS,
    COLLECTION_BY_GENRE_SET_GENRE,
    COLLECTION_CLEAR_GENRES,
    COLLECTION_REQUEST_GENRES,
    COLLECTION_SUCCESS_GENRES,
    CollectionAction
} from './types';

const initialCollectionState = { products: { loading: true, count: 0, list: [] } } as CollectionState;

export function collectionReducer(
    collection: CollectionState = initialCollectionState,
    action: CollectionAction
): CollectionState {
    switch (action.type) {
        case COLLECTION_REQUEST_GENRES:
            return { ...collection, loading: true, isFetchingGenres: true };
        case COLLECTION_SUCCESS_GENRES: {
            const genres = action.payload as GenresResponse;
            return { ...collection, genres: genres, loading: false, isFetchingGenres: false };
        }
        case COLLECTION_CLEAR_GENRES:
            return { ...collection, genres: {} as any, byGenre: undefined };
        case COLLECTION_BY_GENRE_SET_GENRE: {
            const byGenre = action.payload;
            return { ...collection, byGenre: byGenre };
        }
        case COLLECTION_BY_GENRE_PRODUCTS_RESET:
            return { ...collection, products: { count: 0, list: [] } };
        case COLLECTION_BY_GENRE_PRODUCTS_REQUEST:
            return { ...collection, products: { count: 0, list: [], loading: true } };

        case COLLECTION_BY_GENRE_PRODUCTS_SUCCESS: {
            const products = action.payload;
            return {
                ...collection,
                products: {
                    count: products.totalHits,
                    list: products.hits,
                    loading: false
                }
            };
        }
        case COLLECTION_BY_GENRE_PRODUCTS_FAILURE:
            return { ...collection, products: { error: action.error, loading: false } };
        case ANALYSE_REQUEST:
            return { ...collection, loading: true };
        case ANALYSE_SUCCESS: {
            const analyse = action.payload;
            return { ...collection, loading: false, analyse: analyse };
        }
        case ANALYSE_FAILURE:
            return { error: action.error, loading: false, analyseFailed: true };
        case ANALYSE_RESET_AFTER_FAILURE:
            return { analyseFailed: false };
        default:
            return collection;
    }
}
